<script lang="ts" setup>
    import {computed} from "vue";
    import {useHTMLRender} from "../composables/useHTMLRender";

    import type {TextVariantTypes} from "@songfinch/types";

    
    const props = withDefaults(
        defineProps<{
            html?: string;
            baseP?: TextVariantTypes
        }>(),
        {
            html: undefined,
            baseP: "p-4"
        },
    );

    const htmlContent = computed(() => {
        if (props.html) {
            const {htmlContent} = useHTMLRender(props.html, props.baseP);
            return htmlContent;
        }
        return "";
    });

</script>

<template>
    <div v-if="htmlContent" v-html="htmlContent"/>
</template>

<style lang="scss" scoped>
li {
  .h-1,
  .h-2,
  .h-3,
  .h-4,
  .h-5,
  .h-6,
  .p-2 {
    @extend %p-2;
    margin-bottom: 1rem;
  }
}

:deep(a) {
    text-decoration: underline !important;
}
</style>